<template>
  <div class="container-fluid clinic-expenses" style="margin-top: 40px">

    <clinic-show-expense ref="showexpense" @submit="onSubmit"></clinic-show-expense>

    <div class="row">
      <!-- LEFT COLUMN -->
      <div class="col-md-2">
        <h1 class="clinic-expenses__title">
          RESUMEN
        </h1>

        <div v-if="summary.amount" class="clinic-expenses__section">
          <h5>TOTALES</h5>
          <div>
            <strong>Importe:</strong>
            <span class="float-right">
              {{ total_amount }}
            </span>
          </div>
          <div>
            <strong>Impuestos:</strong>
            <span class="float-right">
              {{ total_vat }}
            </span>
          </div>
          <div>
            <strong>Total:</strong>
            <span class="float-right">
              {{ total_net_amount }}
            </span>
          </div>
        </div>

        <div v-for="tsum in tax_summaries" class="clinic-expenses__section">
          <h5>{{ tsum.name }}</h5>
          <div>
            <strong>Importe:</strong>
            <span class="float-right">
              {{ tsum.total_amount }}
            </span>
          </div>
          <div>
            <strong>Impuestos:</strong>
            <span class="float-right">
              {{ tsum.total_vat }}
            </span>
          </div>
          <div>
            <strong>Total:</strong>
            <span class="float-right">
              {{ tsum.total_net_amount }}
            </span>
          </div>
        </div>


      </div>
      <!-- CENTER COLUMN -->
      <div class="col-md-8">
        <div class="row">
          <div class="col">
            <h1 class="clinic-expenses__title">
              GASTOS
            </h1>
          </div>
        </div>
        <div class="clinic-expenses__inputs row form-group">
          <div class="col-sm-2">
            <select id="clinic_expenses_period" v-model="period" class="custom-select">
              <option value="day">Hoy</option>
              <option value="day_prior">Ayer</option>
              <option value="week">Esta semana</option>
              <option value="week_prior">Semana pasada</option>
              <option value="month">Este mes</option>
              <option value="month_prior">Mes pasado</option>
              <option value="trimester">Este trimestre</option>
              <option value="trimester_prior">Trimestre pasado</option>
              <option value="year">Este año</option>
              <option value="past_year">Año pasado</option>
              <option value="custom">Personalizado</option>
            </select>
            <label for="clinic_expenses_period" class="wabident-info">Periodo</label>
          </div>

          <transition name="fade">
            <div class="col-sm-2" v-if="period == 'custom'">
              <input v-model="date_from" id="clinic_expenses_date_from" type="date" class="form-control" />
              <label class="wabident-info" for="clinic_expenses_date_from">Desde:</label>
            </div>
          </transition>

          <transition name="fade">
            <div class="col-sm-2" v-if="period == 'custom'">
              <input v-model="date_to" id="clinic_expenses_date_to" type="date" class="form-control" />
              <label class="wabident-info" for="clinic_expenses_date_to">Hasta:</label>
            </div>
          </transition>

          <template v-if="show_clinic_selector">
            <div class="col-sm-2">
              <select id="clinic_expenses_clinic_id" v-model="clinic_id" class="custom-select">
                <option :value="null">Todas</option>
                <option v-for="(name, id) in clinics" :key="id" :value="id">
                  {{ name }}
                </option>
              </select>
              <label for="clinic_expenses_clinic_id" class="wabident-info">Clínica</label>
            </div>
          </template>

          <div class="col-sm-3">
            <v-select multiple class="wabident-selector" :options="provider_families" placeholder="Escoge tipo ..."
              v-model="provider_family_ids" :reduce="(x) => x.value"></v-select>
            <label class="wabident-info">Tipo de Gasto</label>
          </div>

        </div>

        <div v-if="!is_loading" class="clinic-expenses__list">
          <table class="table">
            <thead>
              <tr>
                <th>CLÍNICA</th>
                <th>FECHA</th>
                <th>TIPO</th>
                <th>CONCEPTO</th>
                <th>IMPORTE</th>
                <th>IVA(%)</th>
                <th class="text-center">ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              <clinic-expense v-for="(expense, index) in search_expenses" class="clinic-expenses__row"
                :expense="expense" :key="index" :clinics="clinics" @edit="updateExpense"
                @delete="deleteExpense"></clinic-expense>
            </tbody>
          </table>
        </div>
        <div v-else class="clinic-expenses__loading text-center">
          <h2>
            Buscando
            <i class="fas fa-spin fa-circle-notch"></i>
          </h2>
        </div>

        <!-- PAGINATION -->
        <div v-if="has_results_available" class="row">
          <div class="col text-center customer-search-pagination my-2">
            <button :disabled="is_first_page" @click="goFirst" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-double-left"></i>
            </button>
            <button :disabled="is_first_page" @click="goPrev" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-left"></i>
            </button>
            <label class="customer-search-pagination-locator mx-2">
              Página
              {{ current_page }} de {{ total_pages }}
            </label>
            <button :disabled="is_last_page" @click="goNext" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-right"></i>
            </button>
            <button :disabled="is_last_page" @click="goLast" type="button"
              class="btn btn-primary btn-wabident-round mx-1">
              <i class="fas fa-angle-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="col-md-2">
        <h1 class="clinic-expenses__title">ACCIONES</h1>
        <div class="clinic-expenses__inputs row form-group">
          <button :disabled="is_loading" @click="createExpense" class="
                    btn btn-primary btn-wabident btn-block
                    d-flex
                    align-items-center
                    justify-content-center
                  ">

            <i style="font-size: 24px; margin-right: 20px" class="fas fa-plus"></i>
            Añadir &hellip;
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 0,
      is_loading: false,
      period: "day",
      date_from: new Date().toISODate(),
      date_to: new Date().toISODate(),
      provider_family_ids: [],
      clinic_id: null,
      expenses: null,
      summary: [],
    };
  },
  computed: {
    provider_families() {
      if (!this.clinic) {
        return [];
      }

      return this.clinic.provider_families.map((family) => {
        return {
          label: family.name,
          value: family.id,
        };
      });
    },
    total_amount() {
      return this.summaryField(this.summary.amount);
    },
    total_vat() {
      return this.summaryField(this.summary.vat_amount);
    },
    total_net_amount() {
      return this.summaryField(this.summary.net_amount);
    },
    tax_summaries() {
      let ret = [];

      if (!this.summary.by_vat) {
        return ret;
      }

      this.clinic.taxes.forEach((tax) => {
        const vat_index = Number(tax.value);
        const summary = this.summary.by_vat[vat_index];
        if (summary) {
          ret.push({
            name: tax.name,
            total_amount: this.summaryField(summary.amount),
            total_vat: this.summaryField(summary.vat_amount),
            total_net_amount: this.summaryField(summary.net_amount),
          });
        };
      });

      return ret;
    },
    show_clinic_selector() {
      return Object.keys(this.clinics).length > 1;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.expenses.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.expenses.current_page == this.expenses.last_page;
    },
    is_first_page() {
      if (!this.has_results_available) return true;
      return this.expenses.current_page == 1;
    },
    is_last_page() {
      if (!this.has_results_available) return true;
      return this.expenses.current_page == this.expenses.last_page;
    },
    search_expenses() {
      if (this.is_searching) return [];
      if (!this.expenses) return [];
      if (!this.expenses.data) return [];
      return this.expenses.data;
    },
    current_page() {
      if (!this.has_results_available) return 0;
      return this.expenses.current_page;
    },
    total_pages() {
      if (!this.has_results_available) return 0;
      return this.expenses.last_page;
    },
    has_results_available() {
      if (this.is_loading) {
        return false;
      }

      if (!this.expenses) {
        return false;
      }

      return this.expenses.data.length > 0;
    },
    is_aesthetic() {
      if (!this.clinic) return false;
      return this.clinic.type == "aesthetic";
    },
    clinics() {
      if (!this.clinic) return [];
      return this.clinic.clinic_names;
    },
    ...mapGetters(["msgwindow", "clinic", "errorwindow", "is_core"]),
  },
  watch: {
    provider_family_ids() {
      this.page = 1;
      this.loadExpenses();
    },
    type(val) {
      this.page = 1;
      this.loadExpenses();
    },
    period(val) {
      this.page = 1;
      this.loadExpenses();
    },
    date_from(val) {
      this.page = 1;
      this.loadExpenses();
    },
    date_to(val) {
      this.page = 1;
      this.loadExpenses();
    },
    clinic_id(val) {
      this.page = 1;
      this.loadExpenses();
    },
    is_invoiced(val) {
      this.page = 1;
      this.loadExpenses();
    },
  },
  methods: {
    summaryField(value) {
      if (!value) return "0,00 €";
      return WabiDent.fmtMoney(value, 2);
    },
    onSubmit() {
      this.page = 1;
      this.loadExpenses();
    },
    updateExpense(expense) {
      this.$refs.showexpense.showEdit(expense);
    },
    deleteExpense(expense) {
      this.errorwindow.show('Confirmar Borrado', '¿Borrar el gasto? Esta operación no se puede deshacer', 'Borrar', 'Cancelar', () => {
        this.doDeleteExpense(expense);
      });
    },
    doDeleteExpense(expense) {
      if (!expense) {
        return;
      }

      axios.post(`/clinic/expenses/${expense.id}`, { '_method': 'delete' })
        .then(() => {
          this.msgwindow.success('Gasto borrado con éxito');
        }).catch(() => {
          this.msgwindow.error('Error borrando el Gasto. Por favor, contacte con el Administrador');
        }).then(() => {
          this.page = 1;
          this.loadExpenses();
        });
    },
    userCan(cap) {
      if (!this.clinic) return false;
      if (!this.clinic.capabilities) return false;
      return this.clinic.capabilities[cap] || false;
    },
    generateReport(type) {
      let params = {
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        clinic_id: this.clinic_id,
        provider_family_ids: this.provider_family_ids,
      };

      params[type] = true;

      let query_params = [];
      for (let field in params) {
        let val = params[field];

        if (val) {
          if (Array.isArray(val)) {
            val.forEach((v) => {
              if (v) {
                query_params.push(`${field}[]=${v}`);
              }
            });
          } else {
            query_params.push(`${field}=${params[field]}`);
          }
        }
      }

      window.open("/clinic/expenses?" + query_params.join("&"), "_blank");
    },
    loadExpenses() {
      if (!this.is_loading) {
        this.is_loading = true;
        let params = {
          period: this.period,
          date_from: this.date_from,
          date_to: this.date_to,
          clinic_id: this.clinic_id,
          provider_family_ids: this.provider_family_ids,
          page: this.page,
        };
        axios
          .get("/clinic/expenses", { params })
          .then((response) => {
            this.expenses = response.data.expenses;
            this.page = response.data.expenses.current_page;
            this.summary = response.data.summary;
            this.date_from = response.data.params.date_from;
            this.date_to = response.data.params.date_to;
          })
          .catch((error) => {
            console.log("[ERR] loadExpenses ", error);
            this.msgwindow.error("Error cargando pagos");
          })
          .then(() => {
            this.is_loading = false;
          });
      }
    },
    createExpense() {
      this.$refs.showexpense.showNew();
    },
    goFirst() {
      this.page = 1;
      this.loadExpenses();
    },
    goPrev() {
      this.page -= 1;
      this.loadExpenses();
    },
    goNext() {
      this.page += 1;
      this.loadExpenses();
    },
    goLast() {
      this.page = this.total_pages;
      this.loadExpenses();
    },
  },
  mounted() {
    this.clinic_id = this.clinic.id;
    this.loadExpenses();
  },
};
</script>

<style lang="scss">
.clinic-expenses {
  &__title {
    font-size: 32px;
    color: var(--theme-text-color);
    font-weight: 800;
    letter-spacing: 0.5px;
    line-height: 1.31;
    margin-bottom: 25px;
  }

  &__section {
    h5 {
      font-weight: bold;
      font-size: 18px;
      font-weight: 800;
      border-bottom: 1px var(--theme-grey-bg) solid;
      padding-bottom: 7.5px;
    }

    padding: 15px;
    margin-bottom: 10px;
  }

  &__list {
    width: 100%;

    table {
      th {
        font-size: 15px;
        letter-spacing: 0.3px;
        color: var(--theme-grey);
        border: none;
        position: sticky;
        top: 0;
        z-index: 1;
        background: white;
        border-bottom: 1px #e0e0e0 solid;
      }

      &__row {
        cursor: pointer;
        background-color: transparent;
        transition: all 0.2s;
        border-bottom: 1px #e0e0e0 solid;
        border-top: 1px #e0e0e0 solid;

        &:hover {
          background-color: var(--theme-highlight);
        }

        td {
          font-size: 16px;
          line-height: 20px;
          color: var(--theme-text-color);
        }
      }
    }
  }
}
</style>
